import { render, staticRenderFns } from "./NotUploaded.vue?vue&type=template&id=0b32879c&scoped=true&"
import script from "./NotUploaded.vue?vue&type=script&lang=js&"
export * from "./NotUploaded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b32879c",
  null
  
)

export default component.exports